module.exports = __webpack_public_path__ + "static/media/carousel-3.f4f08a58.png";